import { makeStyles } from "@mui/styles";
import { FontFamilySwitch, remCalc } from "../../utils";

export const Contract360Style = makeStyles((theme) => ({
    dropdownNotSelected: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: 6
    },
    dropdownSelected: {
        border: `1px solid ${theme.palette.info.main}`,
        borderRadius: 6,
        background: theme.palette.info.light
    },
    optionHeader: {
        fontSize: remCalc(12),
        fontFamily: FontFamilySwitch().bold,
        color: theme.typography.color.primary
    },
    optionSubTitle: {
        fontSize: remCalc(12),
        fontFamily: FontFamilySwitch().regular,
        color: theme.typography.color.secondary
    },
    dot: {
        height: 6,
        width: 6,
        background: theme.palette.border.secondary,
        borderRadius: 50,
        marginInline: "16px"
    },
    resetBtn: {
        height: 40,
        color: theme.typography.color.primary,
        fontSize: remCalc(14),
        fontFamily: FontFamilySwitch().bold,
        "&:hover": {
            background: "transparent"
        }
    },
    searchBtn: {
        height: 40,
        fontSize: remCalc(14),
        fontFamily: FontFamilySwitch().bold,
    },
    contractDetailHeader: {
        fontSize: remCalc(12),
        fontFamily: FontFamilySwitch().semiBold,
        color: theme.typography.color.secondary
    },
    tabs: {
        width: "100%",
        borderBottom: `1px solid ${theme.palette.border.secondary}`
    },
    tabTitle: {
        fontSize: remCalc(14),
        fontFamily: FontFamilySwitch().semiBold,
    },
    noContractDisplay: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 300px)"
    },
    noContractText: {
        fontSize: remCalc(14),
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().semiBold,
    },
    img: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: theme.palette.borderRadius,
        padding: "12px",
    }
}))